import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export class AuthConverter {
  convertUserData(data) {
    const convertedData = {
      id: data.id,
      email: data.email,
      currency: data.currency,
      firstName: data.first_name,
      lastName: data.last_name,
      role: +data.role,
      isPartner: data.is_partner,
      typePartnerPayment: data.type_partner_payment,
      isWithdrawalAccess: data.is_withdrawal_access,
      isDepositAccess: data?.is_deposit_access ?? true,
      username: data.username,
    };
    return convertedData;
  }

  convertBalance(data) {
    const convertedData = {
      balance: data.balance,
      bonusBalance: +data.bonus_balance,
      currency: data.currency,
      isBanned: data.is_banned,
    };
    return convertedData;
  }

  convertNotifications(data) {
    const responseData = data?.payment_notifications;

    if (!responseData) return [];

    return Object.keys(responseData)
      .map((key) => ({
        id: key,
        isNew: responseData[key]?.is_new,
        date: responseData[key]?.notification?.date
          ? dayjs(responseData[key].notification.date.split('.')[0], 'YYYY-MM-DD HH:mm:ss')
            .subtract(3, 'hour')
            .format('DD.MM.YYYY HH:mm:ss')
          : null,
        type: responseData[key]?.notification?.type,
        amount: responseData[key]?.notification?.amount,
        fromId: responseData[key]?.notification?.from_id,
        currency: responseData[key]?.notification?.currency,
      }))
      .sort(
        (a, b) =>
          dayjs(b.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf() -
          dayjs(a.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf(),
      )
      .valueOf();
  }
}
